// extracted by mini-css-extract-plugin
export default {"icon":"searchBar_icon__RSUda","button":"searchBar_button__+b1gQ"};